import { IForceSyncOrderStatusRule } from '../force-sync-order-status-rule.interface';

export class RejectedForceSyncRule implements IForceSyncOrderStatusRule {
  showForceSync(): boolean {
    return false;
  }
}
